const KEY = 'safepass.deviceId';

/**
 * A stable identifier for this browser.
 *
 * The API rate-limits failed verifications per device (5 per 10 minutes) and
 * records the device on every gate event, so the web gate app has to present
 * something stable — the native apps use a keychain value. A browser has no
 * device identity, so this mints one on first use and keeps it in
 * localStorage.
 *
 * Clearing site data yields a new id, which resets that browser's rate-limit
 * window. That is a real difference from the native app and is recorded in
 * docs/DESIGN.md; it is acceptable because the limit is a speed bump against
 * code guessing at a gate, not an authorisation boundary — every attempt is
 * still authenticated as a named gate officer and written to the audit log.
 */
export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return existing;
    const id = `web-${crypto.randomUUID()}`;
    localStorage.setItem(KEY, id);
    return id;
  } catch {
    /* Private browsing with storage blocked — a per-session id still lets the
       officer work; it just will not persist across reloads. */
    return `web-ephemeral-${Math.random().toString(36).slice(2, 10)}`;
  }
}
